import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

// `seam` codes are made on the lock for the stay; `manual` ones are typed in by
// the host for locks TIDY can't reach, and replace the lock's in the guidebook.
export type ReservationAccessCodeSource = 'seam' | 'manual';

export interface ReservationAccessCode {
  code: string;
  starts_at: string | null;
  ends_at: string | null;
  source: ReservationAccessCodeSource;
  device_name?: string | null;
}

export function manualAccessCode(reservation: { access_codes?: ReservationAccessCode[] } | null | undefined): ReservationAccessCode | null {
  return (reservation?.access_codes ?? []).find((accessCode) => accessCode.source === 'manual') ?? null;
}

@Injectable({ providedIn: 'root' })
export class ReservationAccessCodeService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api_url;

  setManualCode(reservationId: number, code: string): Promise<ReservationAccessCode> {
    return firstValueFrom(
      this.http.put<ReservationAccessCode>(this.url(reservationId), { code })
    );
  }

  clearManualCode(reservationId: number): Promise<void> {
    return firstValueFrom(this.http.delete<void>(this.url(reservationId)));
  }

  private url(reservationId: number): string {
    return `${this.baseUrl}api/v1/customer/guest-reservations/${reservationId}/manual-access-code`;
  }
}
